module.exports = __webpack_public_path__ + "static/media/ic_link_instagram.d96e2ca8.svg";